import './doctor.scss';
import React from 'react';

const DoctorPageHeader = ({ title, extra, action }) => (
  <div className="doctor-page-header">
    <div className="doctor-page-header__main">
      <h1 className="doctor-page-header__title">{title}</h1>
      {extra ? <div className="doctor-page-header__extra">{extra}</div> : null}
    </div>
    {action ? <div className="doctor-page-header__action">{action}</div> : null}
  </div>
);

export default DoctorPageHeader;
